import { LiItem } from "@faire/help-center-self-serve/brand/instantAnswers/instantAnswersComponents/common/LiItem";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Bold } from "@faire/web--source/ui/Typography/Span";
import retailerSettingsProfile from "@faire/web-api--source/routes/www/retailer/settings/profile";
import React, { type JSX } from "react";

export const ResetOrUpdatePasswordIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="You have two options for managing your password:"
          description={{
            img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
          }}
        />
      </Typography>
      <Spacer height="2x" />
      <Typography>
        <Bold>
          <StrictLocalMsg
            defaultMessage="Reset your password, if you’ve forgotten it:"
            description={{
              img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
            }}
          />
        </Bold>
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Click <BoldFormatting>Sign In</BoldFormatting> in the top right corner of the homepage"
              description={{
                img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
              }}
              values={{
                BoldFormatting,
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Enter your email address and press Enter"
              description={{
                img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Click <BoldFormatting>Forgot your password? Reset It</BoldFormatting>"
              description={{
                img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
              }}
              values={{
                BoldFormatting,
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={4}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Check your email (including spam) for a password reset link"
              description={{
                img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={5}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Follow the instructions in the email to reset your password"
              description={{
                img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
      <Spacer height="2x" />
      <Typography>
        <Bold>
          <StrictLocalMsg
            defaultMessage="Update your password, if you know your current password:"
            description={{
              img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
            }}
          />
        </Bold>
      </Typography>
      <Spacer height="1x" />
      <LiItem step={1}>
        <Typography>
          <StrictLocalMsg
            defaultMessage="Go to your <AccountSettingLinkFormatting>Settings</AccountSettingLinkFormatting> page"
            description={{
              img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
            }}
            values={{
              AccountSettingLinkFormatting,
            }}
          />
        </Typography>
      </LiItem>
      <Spacer height="1x" />
      <LiItem step={2}>
        <Typography>
          <StrictLocalMsg
            defaultMessage="Navigate to <BoldFormatting>My profile</BoldFormatting>"
            description={{
              img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
            }}
            values={{ BoldFormatting }}
          />
        </Typography>{" "}
      </LiItem>
      <Spacer height="1x" />
      <LiItem step={3}>
        <Typography>
          <StrictLocalMsg
            defaultMessage="Find the <BoldFormatting>Password</BoldFormatting> section and follow the prompts to change your password."
            description={{
              img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
            }}
            values={{ BoldFormatting }}
          />
        </Typography>
      </LiItem>
      <Spacer height="2x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="If you’re having trouble resetting or updating your password, please contact us using the options below."
          description={{
            img: "https://cdn.faire.com/fastly/670eaf4b6d8efa0d874f884af0d0763cc82e180bcec28777b4898fb4f3f98bfc.png",
          }}
        />
      </Typography>
    </Column>
  );
};

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
const AccountSettingLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={retailerSettingsProfile()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);
